import React from 'react';
import styled from 'styled-components';
import AIBrainIcon from '../../../images/AI_Brain_Icon.gif';
import { PROCESSING_MESSAGES } from 'constants/aiVariantImport';
import { TEXT_LABELS } from 'constants/productDetails';

const ProcessingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ProcessingTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.5rem 0;
`;

const ProcessingText = styled.p`
  color: #4b5563;
  margin: 0;
`;

const ProcessingState: React.FC = () => {
  return (
    <ProcessingContent>
      <img src={AIBrainIcon} alt="Some AI going on..." width="120" />
      <ProcessingTitle>
        {TEXT_LABELS.AI_PROCESSING_MESSAGE}
      </ProcessingTitle>
      <ProcessingText>
        {PROCESSING_MESSAGES[Math.floor(Math.random() * PROCESSING_MESSAGES.length)]}
      </ProcessingText>
    </ProcessingContent>
  );
};

export default ProcessingState;

